/**
 * Handles actions related to textbox type of field settings
 * 
 * We want to prevent script usage in the Advanced section labels
 * 
 * @package Ninja Forms builder
 * @subpackage Fields - Edit Field Drawer
 * @copyright (c) 2024 Saturday Drive
 * @since 3.8
 */
define( 'controllers/app/textboxSetting',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {

			// Respond to requests for field setting filtering.
			nfRadio.channel( 'textbox' ).reply( 'validate:updateSetting', this.validateSetting, this );
		},

		/**
		 * Sanitize field as needed to prevent xss
		 * 
		 * @since  3.8
		 * @param  Object 			e                event
		 * @param  backbone.model 	fieldModel       field model
		 * @param  string 			name             setting name
		 * @param  backbone.model 	settingTypeModel field type model
		 * @return escaped data after error triggered
		 */
		validateSetting: function( e, fieldModel, dataModel ) {
            //Check characters set in custom classes match sanitize_html_class
			if ( fieldModel.get('name').endsWith("_class" )) {
				const regexp = /^[a-zA-Z 0-9-_]+$/;
				if(e.target.value.search(regexp) === -1 &&  '' !== e.target.value){
					fieldModel.set('error', nfi18n.htmlDetectedError );
				} else if(e.target.value.search(regexp) === 0 || '' === e.target.value){
					fieldModel.unset('error');
				}
			}
			
            //Prevent xss from title and labels
			const isActionNameLabel = fieldModel.get('name') === "label" && fieldModel.get('label') === "Action Name";
            const checkedElements = ["title", "processing_label", "changeEmailErrorMsg", "changeDateErrorMsg", "confirmFieldErrorMsg", "fieldNumberNumMinError", "fieldNumberNumMaxError", "fieldNumberIncrementBy", "formErrorsCorrectErrors", "validateRequiredField", "honeypotHoneypotError", "fieldsMarkedRequired"];
            if( checkedElements.includes(fieldModel.get('name')) || isActionNameLabel ){
				const regexp = /[/"<>`]/;
				if(e.target.value.search(regexp) !== -1 &&  '' !== e.target.value){
					const foundIndex = e.target.value.search(regexp);
					const foundChar = e.target.value.charAt(foundIndex);
					fieldModel.set('error', foundChar + " " + nfi18n.titleLabelsErrorMessage);
				} else if(e.target.value.search(regexp) === -1 || '' === e.target.value){
					fieldModel.unset('error');
				}
			}
		}

	});

	return controller;
} );
